import React from 'react';
import { Minus, Plus } from 'lucide-react';

interface NumberStepperProps {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (next: number) => void;
  hint?: string;
  compact?: boolean;
}

/**
 * Selector numérico compacto (− valor +) para reemplazar filas largas de pill-buttons
 * (ej. "3…16") por un control de una sola línea. Pensado para vivir en headers
 * densos donde el scroll vertical es un problema.
 */
export function NumberStepper({ label, value, min, max, onChange, hint, compact = false }: NumberStepperProps) {
  const canDecrease = value > min;
  const canIncrease = value < max;

  return (
    <div className={compact ? 'rubric-stepper rubric-stepper--compact' : 'rubric-stepper'}>
      <span className="rubric-stepper__label">{label}</span>
      <div className="rubric-stepper__control">
        <button
          type="button"
          className="rubric-stepper__btn"
          onClick={() => canDecrease && onChange(value - 1)}
          disabled={!canDecrease}
          aria-label={`Reducir ${label}`}
        >
          <Minus className="h-3 w-3" strokeWidth={3} />
        </button>
        <span className="rubric-stepper__value" aria-live="polite">
          {value}
        </span>
        <button
          type="button"
          className="rubric-stepper__btn"
          onClick={() => canIncrease && onChange(value + 1)}
          disabled={!canIncrease}
          aria-label={`Aumentar ${label}`}
        >
          <Plus className="h-3 w-3" strokeWidth={3} />
        </button>
      </div>
      {hint ? <span className="rubric-stepper__hint">{hint}</span> : null}
    </div>
  );
}
